import { MoviesSlider } from "./categoryList";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { useCallback } from "react";
import { BackBarButtonMini } from "../common/backBarButton";
import { getArtistImageURL } from "../../utils/api.utils";
import smoothScroll from "../../utils/animateScroll";
import { getVerticalFocusScrollTarget } from "../../utils/focusScroll";
import { useInputMode } from "../../utils/hooks/useInputMode";

export function getArtistDisplayText(value) {
  if (value == null) return "";

  var text = String(value).replace(/^\s+|\s+$/g, "");
  var normalized = text.toLowerCase();

  if (!text || normalized === "undefined" || normalized === "null") return "";
  return text;
}

const ArtistContent = ({ data }) => {
  const { ref, focusKey } = useFocusable();
  const { artist, movies } = data;
  const { isMouseFocus } = useInputMode();
  const farsiName = getArtistDisplayText(artist?.farsiName);
  const englishName = getArtistDisplayText(artist?.englishName);
  const description = getArtistDisplayText(artist?.description);

  const onRowFocus = useCallback(
    (props) => {
      if (isMouseFocus) return;
      const targetScroll = getVerticalFocusScrollTarget(ref.current, props || {}, {
        topPadding: 88,
        bottomPadding: 128,
      });

      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <div className="legacy-route-content legacy-artist-detail-route">
      <FocusContext.Provider value={focusKey}>
        <div className="legacy-route-scroll" ref={ref}>
          <div className="legacy-artist-detail">
            <div className="legacy-artist-detail-back">
              <BackBarButtonMini />
            </div>

            <div className="legacy-artist-detail-hero">
              <img
                className="legacy-artist-detail-image"
                src={getArtistImageURL(artist?.image)}
                alt={farsiName || englishName}
              />
              <div className="legacy-artist-detail-copy">
                {farsiName ? (
                  <h1 className="legacy-artist-detail-name-fa">
                    {farsiName}
                  </h1>
                ) : null}
                {englishName ? (
                  <div className="legacy-artist-detail-name-en">
                    {englishName}
                  </div>
                ) : null}
                {description ? (
                  <p className="legacy-artist-detail-description">
                    {description}
                  </p>
                ) : null}
              </div>
            </div>

            {movies?.length > 0 ? (
              <MoviesSlider
                rowTitle={""}
                movies={movies}
                onFocus={onRowFocus}
                nextPlayGuide={{
                  type: "artist",
                  slug: artist?.slug,
                  name: farsiName || englishName,
                }}
              />
            ) : (
              <div className="legacy-artist-detail-empty">
                محتوایی یافت نشد
              </div>
            )}
          </div>
        </div>
      </FocusContext.Provider>
    </div>
  );
};

export default ArtistContent;
